import { render, staticRenderFns } from "./AddAssignmentWrapper.vue?vue&type=template&id=5bf41370&scoped=true&"
import script from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
export * from "./AddAssignmentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AddAssignmentWrapper.vue?vue&type=style&index=0&id=5bf41370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf41370",
  null
  
)

export default component.exports